export default __webpack_public_path__ + "static/Syllabus2023-6c980a5a1702868367e3a059a6bfef52.pdf";